import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import { getEnteredEmployeeCodeService } from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const enteredEmployeeCodeAdminContext = createContext({
  codes: [],
  setCodes: () => {},
  search: "",
  setSearch: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleGetEnteredEmployeeCode: () => {},
});

const EnteredEmployeeCodeAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [codes, setCodes] = useState([]);
  const [search, setSearch] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  // Handle Get Use Discounts Method
  const handleGetEnteredEmployeeCode = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
      search,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getEnteredEmployeeCodeService(objData);
      if (status === 200) {
        setCodes(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <enteredEmployeeCodeAdminContext.Provider
      value={{
        codes,
        setCodes,
        search,
        setSearch,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        handleGetEnteredEmployeeCode,
      }}
    >
      {children}
    </enteredEmployeeCodeAdminContext.Provider>
  );
};

export default EnteredEmployeeCodeAdminContext;
